import {useCallback, useState} from 'react';

export function useUpdate() {
    const [, setTick] = useState(0);

    const update = useCallback(() => {
        setTick(tick => tick + 1);
    }, []);

    return update;
}
